import { HashRouter } from 'react-router-dom'
import { Toaster } from 'sonner'
import { AppRoutes } from './routes'
import { MainLayout } from './components/layout/MainLayout'
import { I18nProvider } from './i18n'

function App() {
  return (
    <I18nProvider>
      <HashRouter>
        <MainLayout>
          <AppRoutes />
        </MainLayout>
        <Toaster position="top-right" richColors />
      </HashRouter>
    </I18nProvider>
  )
}

export default App
